import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { create } from './table-schema';
import timeFormAPI from '../../api/ui/timeFormAPI';
import { getMediaType, mediaType } from '../../utils/enum';

function useSchemaImageUpload() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    'admin.app.image.upload.table.head.no', // "파일 번호",
    'admin.app.image.upload.table.head.preview', // "등록된 미디어 파일 미리보기",
    'admin.app.image.upload.table.head.path', // "미디어 파일 경로",
    'admin.app.image.upload.table.head.created', // "업로드(생성) 날짜",
  ];

  /**
   *
   * @param {String} path
   */
  const getFileType = (path) => {
    const ext = path.split('.').at(-1);
    return getMediaType(ext);
  };

  const getPreview = (row) => {
    if (row?.path) {
      const type = getFileType(row.path);
      if (type === mediaType.image) {
        return <img className="tableMedia" alt="" src={row?.path}/>;
      }
      if (type === mediaType.video) {
        return (
          <video className="tableMedia" src={row?.path} autoPlay loop muted />
        );
      }
      return <></>;
    }
  };

  const getLink = (row) => {
    if (row?.path) {
      return (
        <a href={`${row.path}`} target="_blank" rel="noreferrer">
          {`${row.path}`}
        </a>
      );
    }
    return <></>;
  };

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const no = row?.fileNo || 0;
    const preview = getPreview(row);
    const path = getLink(row);
    const createdAt = timeFormAPI.changeDataLog(row?.createAt);

    return {
      key: no, // 키는 반드시 있어야 한다.
      param1: no,
      param2: preview,
      param3: path,
      param4: createdAt,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaImageUpload;
